import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SafetySopralluoghiService {
    static byAzienda = (id_azienda, anno = "") => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/byAzienda`;
            const payload = { id_azienda };
            if (anno) payload.anno = anno;
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };

    static nonConformitaByAzienda = (id_azienda, soloAperte = false) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/nonConformitaByAzienda`;
            ApiService.postRequest(resolve, reject, url, {
                id_azienda,
                solo_aperte: soloAperte ? 1 : 0,
            });
        });
    };

    static stats = (id_azienda) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/stats`;
            ApiService.postRequest(resolve, reject, url, { id_azienda });
        });
    };

    static createSopralluogo = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/createSopralluogo`;
        return ApiService.postFormData(url, formData);
    };

    static createNonConformita = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/createNonConformita`;
        return ApiService.postFormData(url, formData);
    };

    static updateNonConformita = (formData) => {
        const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/updateNonConformita`;
        return ApiService.postFormData(url, formData);
    };

    static deleteSopralluogo = (id_sopralluogo) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/deleteSopralluogo`;
            ApiService.postRequest(resolve, reject, url, { id_sopralluogo });
        });
    };

    static deleteNonConformita = (id_non_conformita) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/deleteNonConformita`;
            ApiService.postRequest(resolve, reject, url, { id_non_conformita });
        });
    };

    static download = (id_sopralluogo, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/download`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_sopralluogo, filename });
        });
    };

    static downloadNc = (id_non_conformita, filename) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/sopralluoghi/downloadNc`;
            ApiService.postRequestWithDownload(resolve, reject, url, { id_non_conformita, filename });
        });
    };
}
